import React from 'react';
import ReactDOM from 'react-dom';

import PopoverStore from 'components/popover/PopoverStore.js';

export default class Popover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialRender: false,
      isPopoverShown: false,
      popOverStyle: {},
    };
    this._onClosePopover = this._onClosePopover.bind(this);
    this.onClickKill = this.onClickKill.bind(this);
  }

  componentDidMount() {
    document.addEventListener('popover:closed', this._onClosePopover, this);
  }

  componentWillUnmount() {
    document.removeEventListener('popover:closed', this._onClosePopover, this);
  }

  componentWillReceiveProps(newProps) {
    if (!_.isEqual(newProps, this.props) && newProps.active) {
      if (!this.state.initialRender) {
        // Setting a timeout of 75ms here so the popover position can catch up with the render
        setTimeout(() => this._positionPopOver(null, newProps.popTarget), 75)
        this.setState({ initialRender: true });
      } else {
        this.forceUpdate(() => this._positionPopOver(null, newProps.popTarget));
      }
    }
  }

  isOpen() {
    return this.state.isPopoverShown;
  }

  show(e) {
    PopoverStore.register(this.hide);
    this.setState({ isPopoverShown: true });
    if (this.props.onShow) {
      this.props.onShow(e);
    }
  }

  hide(e) {
    this.setState({ isPopoverShown: false });
    if (this.props.onHide) {
      this.props.onHide(e);
    }
  }

  toggle(event, keepOpen) {
    if (!keepOpen) {
      const openPops = document.querySelectorAll('.popover--active');
      [].forEach.call(openPops, (popOver) => {
        popOver.classList.remove('popover--active');
        popOver.classList.remove('anim__open');

        Utils.fireEvent(popOver, 'popover:closed', { popOver });
      });
    }
    if (this.state.isPopoverShown && !keepOpen) {
      this.togglePopoverShown(false);
      PopoverStore.unregister(this.hide);
      if (this.props.onHide) {
        this.props.onHide(event);
      }
    } else {
      this.togglePopoverShown(true);
    }
    if (!Utils.isNotDefined(event)) {
      this._positionPopOver(event);
    }
  }

  _positionPopOver(event, target) {
    // backwards compatibility. Can be removed when all popovers have been
    // converted.
    if (event != null) {
      if (Utils.isNotDefined(event.target)) {
        target = ReactDOM.findDOMNode(event);
      } else {
        target = event.target;
      }
    }
    const pop = ReactDOM.findDOMNode(this);
    const popContent = pop.querySelector('.popover__content');

    // this is the height of the arrow this points at the selected item. This
    // is defined in the the pseudo class :after and isn't easily accessible
    // via JS.
    const arrowHeightOffset = 18;
    const headerHeightOffset = 200;

    // get position of the clicked element this is launching the popover.
    const pos = this.getPosition(target);
    const offsetTop = pos.y;

    // get the offsetHeight of the popover
    const popHeight = popContent.offsetHeight;

    // I think this can be hardcoded, I believe all popovers have consistent padding.
    // Again, what is better, relying on ReactDOM.findDOMNode or hardcoding a value?
    const paddingBottom = 20; // parseInt(window.getComputedStyle(popContent).paddingBottom);

    let sideHeight = 0;
    let newHeight = 0;
    switch (this.props.position) {
      case 'right':
      case 'left':
        sideHeight = $('#schedule-content-container').offsetHeight;
        newHeight = pos.y + popHeight;
        if (sideHeight > newHeight) {
          newHeight = sideHeight;
        }

        // Calculate new position of popover.
        let topPos;
        if (pop.classList.contains('popovertimeoff')) {
          // For time off requests:
          //
          // 1. Find the offset of the Create Request button
          // 2. Subtract half the height of the pop over
          // 3. Subtract the offset of sidebarContainer
          // 4. Add side arrowHeight to push it up a bit
          // 5. Add about 10 pixels to push it down a bit
          const buttonOffset = $('.create-timeoff-button').offset().top;
          const sideBarOffset = $('.sidebarContainer').offset().top;

          topPos = buttonOffset - popHeight / 2 - sideBarOffset + arrowHeightOffset + 10;
        } else {
          topPos = Math.abs(
            offsetTop
              - (popHeight + headerHeightOffset) / 2
              + arrowHeightOffset / 2
          );
        }

        this.setState({
          popOverStyle: { top: `${topPos}px`, left: '-15px' },
        });
        break;
      case 'bottom':
        // nothing to do here yet.
        sideHeight = $('#schedule-content-container').offsetHeight;
        newHeight = pos.y - popHeight - paddingBottom - arrowHeightOffset;
        if (sideHeight > newHeight) {
          newHeight = sideHeight;
        }
        break;
      case 'top':
        // nothing to do here yet.
        sideHeight = $('#schedule-content-container').offsetHeight;
        newHeight = pos.y + popHeight + paddingBottom + arrowHeightOffset;
        if (sideHeight > newHeight) {
          newHeight = sideHeight;
        }
        break;
      default:
        this.forceUpdate();
        this.setState({
          popOverStyle: {},
        });
    }
    Utils.resizeContainer(newHeight);
  }

  getPosition(el) {
    let posX = 0;
    let posY = 0;
    const offset = $(el).offset();
    if (typeof offset !== 'undefined') {
      posY = offset.top;
      posX = offset.left;
    }

    return {
      x: posX,
      y: posY,
    };
  }

  togglePopoverShown(bool) {
    if (this.state.isPopoverShown != bool) {
      this.setState({
        isPopoverShown: bool,
      });
    }
  }

  onClickKill(e) {
    if (!_.isUndefined(this.props.clearSelectedShiftId)) {
      this.props.clearSelectedShiftId();
    }
    e.stopPropagation();
  }

  _onClosePopover(e) {
    // ensure popover dispatching the event is this popover.
    // legit use of findDOMNode?
    if (e.popOver == ReactDOM.findDOMNode(this)) {
      if (!Utils.isNotDefined(this.props.onHide)) {
        this.togglePopoverShown(false);
        PopoverStore.unregister(this.hide);
        this.props.onHide(e);
      }
    }
  }

  render() {
    let pos = this.props.position;
    if (pos == '') {
      pos = '';
    } else {
      pos = `popover--${this.props.position}`;
    }

    const openClasses = this.props.active ? 'popover--active anim__open' : '';

    if (this.state.isPopoverShown) {
      var popoverClasses = `popover ${this.props.className} ${pos} anim__open popover--active`;
    } else {
      var popoverClasses = `popover ${this.props.className} ${pos}`;
    }

    popoverClasses = `${popoverClasses} ${openClasses}`;
    return (
      <div className={popoverClasses} style={this.state.popOverStyle} onClick={this.onClickKill}>
        <div className="popover__content">{this.props.children}</div>
      </div>
    );
  }
}

Popover.propTypes = {
  className: React.PropTypes.string,
  children: React.PropTypes.node,
  position: React.PropTypes.oneOf(['', 'top', 'right', 'bottom', 'left']),
  onShow: React.PropTypes.func,
  onHide: React.PropTypes.func,
};

Popover.defaultProps = {
  position: '',
};
